import {AbstractControl, ValidationErrors} from '@angular/forms';

export class ColorValidator {

  static readonly instance = new ColorValidator().validate;

  validate(control: AbstractControl): ValidationErrors | null {
    const {value} = control
    if (value?.startsWith('#') && (!/^#[0-9a-f]{6}$/i.test(value))) {
      return {'notAColor': true}
    }
    return null
  }

}
